/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var RadioGroupInjectionKey = Symbol("RadioGroupProvide");
var RadioButtonInjectionKey = Symbol("RadioButtonProvide");

export { RadioButtonInjectionKey, RadioGroupInjectionKey };
//# sourceMappingURL=constants.mjs.map
